// extracted by mini-css-extract-plugin
export default {"root":"_3r1zq24l","preview":"_25mLyhvl","header":"nGysZnGN"};